import DriverDecompositionTable from "../investigations/components/DriverDecompositionTable";
import ForecastChart from "../cost-control/forecast/ForecastChart";

// AssistantDriverBridge adapts the contract's driver_bridge inline data
// ({ total, drivers: [{label, deltaCost, baselineCost, comparisonCost, sharePct}] })
// to the existing DriverDecompositionTable. DriverDecompositionTable's real
// props are `drivers` (array, rendered with `.label`/`.deltaCost`/`.sharePct`,
// plus optional `.priceVolume`/`.dimension`/`.key` we don't have here — it
// degrades gracefully to a plain single-color bar per row) and `highlightKey`.
// It has no `total`/header prop, so the contract's `total` isn't consumed —
// the component only ever renders the per-driver breakdown.
function AssistantDriverBridge({ data }) {
  return <DriverDecompositionTable drivers={data?.drivers || []} />;
}

// AssistantForecastBand adapts the contract's forecast_band series
// (points of {date, actual?, forecast?, lower?, upper?}) to ForecastChart.
// ForecastChart's real `series` prop shape matches the contract exactly
// (date/actual/forecast/lower/upper, plus an optional `budget` the contract
// doesn't send), so no field mapping is needed.
function AssistantForecastBand({ data }) {
  return <ForecastChart series={data?.series || []} />;
}

const REGISTRY = {
  driver_bridge: AssistantDriverBridge,
  forecast_band: AssistantForecastBand,
};

// chartComponentFor returns the component for a visualization.type, or null.
export function chartComponentFor(type) {
  return REGISTRY[type] || null;
}
